import React, { Component } from "react";

import { CSpinner } from "@coreui/react";
import { FaArrowDown, FaArrowUp, FaPlusCircle } from "react-icons/fa";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Alert } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios"; // Evaluation/Question/Create/index.js
import QuestionCreate from "../../pages/Evaluation/Question/Create/index";
import Loading from "../Loading";
import QuestionImportModal from "../QuestionImportModal/QuestionImportModal";
// import Breadcrumb from "../../../../components/Breadcrumb";

import "./styles.css";

class QuestionListCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // loadingData: true,
      nonTimerCalls: 0,

      // activityId: this.props.activityId,

      // modal: this.props.modalCheck,

      listId: undefined,
      name: this.props.name || "",
      questions: [],
      // simulated: false,
      random: false,
      time: 0,
      noTime: true,
      value: "10",
      shareValue: !this.props.editListId,
      // currentValueSum: null,
      executions: 1,
      freeExecutions: true,
      models: 1,
      types: [],
      abilities: [],
      loadingTypes: true,
      used: false,

      userQuestions: [],
      questionsImporter: false,

      loadingSubmit: false
    };

    this.importQuestions = this.addImportedQuestions.bind(this);
    this.importQuestion = this.addImportedQuestion.bind(this);
    this.closeImporter = this.closeQuestionsImporter.bind(this);

    this.idListChanger = this.changeIdList.bind(this);
    this.questionValueChanger = this.changeQuestionValue.bind(this);
    this.questionDuplicator = this.duplicateQuestion.bind(this);
    this.questionDeleter = this.deleteQuestion.bind(this);
    this.shouldUpdateList = this.shouldUpdateList.bind(this);
    this.pullList = this.pullList.bind(this);

    this.timeout = setTimeout(() => {}, 5000);
  }

  componentDidMount() {
    // this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    if (
      !this.state.listId &&
      !this.props.editListId &&
      !this.props.cloneListId
    ) {
      this.setState({
        loadingTypes: false
      });
      return;
    }
    if (this.props.cloneListId) this.cloneList();
    else this.pullList();

    (async () => {
      const respTypes = await axios.get(
        `${URL.api}evaluation/type_question/list`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );

      const respAbilities = await axios.get(
        `${URL.api}classification/ability/list`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );

      this.setState({
        types: respTypes.data.data,
        abilities: respAbilities.data.data,
        loadingTypes: false
      });
    })();
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
    clearInterval(this.interval);
  }

  shouldUpdateList(questionId) {
    const questionIndex = this.state.questions.findIndex(
      question => question.id === questionId
    );

    if (questionIndex === -1) {
      return;
    }

    axios
      .get(`${URL.api}evaluation/question/singleView/${questionId}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(response => {
        if (response.data.success) {
          const updatedQuestion = response.data.data;

          this.setState(prevState => {
            const newQuestions = prevState.questions.map((q, i) => {
              if (i === questionIndex) {
                return {
                  ...updatedQuestion,
                  value: q.value,
                  position: q.position,
                  renderKey: Math.random()
                };
              }
              return q;
            });

            return { questions: newQuestions };
          });
        } else {
          toastr.error("Erro", "Não foi possível atualizar a questão.");
        }
      })
      .catch(error => {
        toastr.error("Erro", "Falha ao atualizar a questão.");
      });
  }

  // Devolve o id criado, além de guardá-lo no state. Quem precisa do id
  // imediatamente (o fluxo de salvar) não pode depender do setState ter sido
  // aplicado: sem isso o callback newList devolvia { id: undefined } e a
  // atividade era gravada com obj_id nulo.
  async createNewList() {
    const obj = {
      name: this.props?.name ?? "Avaliação modelo",
      user_id: this.props.user.user.id,
      activity_id: null,
      simulated: false,
      result_mode: "teste",
      random: false,
      execution_quantity: 1,
      time: 0,
      value: 0,
      questions: [],
      randoms: []
    };

    const resp = await axios.post(
      `${URL.api}evaluation/question/lists/insert`,
      obj,
      {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      }
    );

    if (!resp.data.success) {
      return null;
    }

    this.setState({ listId: resp.data.data });

    return resp.data.data;
  }

  pullList() {
    axios
      .get(
        `${URL.api}evaluation/question/lists/singleView/${
          this.props.editListId || this.props.match.params.id
        }`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        if (resp.data.success) {
          this.setState({
            listId: resp.data.data.id,
            name: resp.data.data.name,
            questions: [...resp.data.data.questions],
            // simulated: resp.data.data.simulated,
            random: resp.data.data.random,
            time: resp.data.data.time,
            value: resp.data.data.value,
            // currentValueSum: resp.data.data.value,
            executions: resp.data.data.execution_quantity,
            freeExecutions: resp.data.data.execution_quantity === 0,
            // randomizer: resp.data.data.randoms,
            noTime: resp.data.data.time === 0,
            used: resp.data.data.used > 0
          });
        }
      });
  }

  cloneList() {
    axios
      .get(
        `${URL.api}evaluation/question/lists/singleView/${this.props.cloneListId}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        if (resp.data.success) {
          const obj = {
            name: this.props?.name
              ? this.props?.name
              : `${resp.data.data.name} (Cópia)`,
            user_id: this.props.user.user.id,
            activity_id: null,
            simulated: resp.data.data.simulated,
            result_mode: "teste",
            random: resp.data.data.random,
            execution_quantity: resp.data.data.execution_quantity,
            time: resp.data.data.time,
            value: resp.data.data.value,
            questions: resp.data.data.questions,
            randoms: resp.data.data.randoms,
            used: resp.data.data.used > 0
          };

          axios
            .post(
              `${URL.api}evaluation/question/lists/insert`,
              {
                ...obj,
                questions: obj.questions.map(question => ({
                  value: question.value,
                  question_id: question.id
                }))
              },
              { headers: { authorization: `Bearer ${this.props.user.token}` } }
            )
            .then(resp => {
              if (resp.data.success) {
                this.setState({
                  listId: resp.data.data,
                  name: obj.name,
                  questions: obj.questions,
                  // simulated: obj.simulated,
                  random: obj.random,
                  time: obj.time,
                  value: obj.value,
                  // currentValueSum: obj.value,
                  executions: obj.execution_quantity
                  // randomizer: obj.randoms
                });
                if (this.props.afterClone) {
                  this.props.afterClone(resp.data.data);
                }
              }
            });
        }
      });
  }

  // listIdOverride permite salvar uma lista recém-criada sem esperar o
  // setState do createNewList. Sem argumento, usa o state (comportamento
  // anterior, preservado para os demais chamadores).
  async updateList(listIdOverride) {
    if (this.state.used) {
      return;
    }

    // Divisão igual da pontuação
    const questionsArray = this.state.questions.slice();
    const newQuestionsArray = questionsArray.map(question => {
      if (this.state.shareValue) {
        question.value = this.state.value / this.state.questions.length;
      }

      return question;
    });

    this.setState({ loadingSubmit: true });

    this.setState(prevState => ({
      nonTimerCalls: ++prevState.nonTimerCalls
    }));

    const questionsToSend = newQuestionsArray.map((question, index) => ({
      question_id: question.id,
      value: question.value,
      order: index + 1,
      difficulty_level_id: 0
    }));

    const timeToSend = () => {
      if (!this.state.noTime) return 0;
      return this.state.time;
    };

    const obj = {
      id: listIdOverride ?? this.state.listId,
      name: this.state.name,
      user_id: this.props.user.user.id,
      activity_id: null,
      simulated: false,
      result_mode: "teste",
      random: this.state.random,
      time: this.state.time,
      value: this.state.value,
      execution_quantity: this.state.freeExecutions ? 0 : this.state.executions,
      questions: questionsToSend,
      models: this.state.models,
      randoms: []
    };

    await axios
      .post(`${URL.api}evaluation/question/lists/newUpdate`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(Response => {
        this.setState({ loadingSubmit: false });
      });
  }

  openUserQuestionsImporter() {
    this.setState({
      questionsImporter: true
    });
  }

  addImportedQuestions(importedQuestions) {
    if (!this.state.listId && !this.props.editListId && !this.props.cloneListId)
      this.createNewList();
    let questionsWithPosition = importedQuestions.map((question, index) => {
      let position = parseInt(this.state.questions?.length) + index;
      let questionWithPosition = {
        ...question,
        position
      };
      return questionWithPosition;
    });
    this.setState(state => ({
      questions: [...state.questions, ...questionsWithPosition]
    }));

    this.closeQuestionsImporter();
  }

  addImportedQuestion(importedQuestion) {
    if (!this.state.listId && !this.props.editListId && !this.props.cloneListId)
      this.createNewList();
    let position = parseInt(this.state.questions?.length) + 1;
    let importedQuestionWithPosition = {
      ...importedQuestion,
      position
    };
    this.setState(state => ({
      questions: [...state.questions, importedQuestionWithPosition]
    }));

    this.closeQuestionsImporter();
  }

  addNewQuestion() {
    let position = parseInt(this.state.questions?.length) + 1;
    this.setState(state => ({
      questions: [...state.questions, { id: undefined, value: 0, position }]
    }));
  }

  pushQuestion(index, direction) {
    let auxQuestions = [];
    if (
      (direction === 1 && index === 0) ||
      (direction === -1 && index === this.state.questions.length - 1) ||
      this.state.used
    ) {
      return;
    }
    for (let i = 0; i < this.state.questions?.length; i++) {
      auxQuestions.push(this.state.questions[i]);
    }
    auxQuestions[index] = {
      ...auxQuestions[index],
      position: index - direction
    };
    auxQuestions[index - direction] = {
      ...auxQuestions[index - direction],
      position: index
    };
    auxQuestions.sort((a, b) => a.position - b.position);
    this.setState(() => ({ questions: auxQuestions }));
  }

  deleteQuestion(index) {
    const newQuestionsArray = this.state.questions;
    newQuestionsArray.splice(index, 1);

    this.setState(() => ({ questions: newQuestionsArray }));
  }

  closeQuestionsImporter() {
    this.setState({ questionsImporter: false });
  }

  changeIdList(newId, index) {
    const newQuestionsArray = this.state.questions;
    newQuestionsArray[index] = { id: newId, value: 0 };
    this.setState(
      () => ({ questions: newQuestionsArray }),
      () => this.updateList()
    );
  }

  duplicateQuestion(duplicatedQuestion, newQuestionId) {
    const newQuestionsArray = [...this.state.questions];
    const index = newQuestionsArray.findIndex(
      question => question.id === duplicatedQuestion
    );
    newQuestionsArray.splice(index, 0, { id: newQuestionId, value: 0 });
    this.setState(() => ({ questions: newQuestionsArray }));
  }

  changeListName(newTitle) {
    this.setState(() => ({ name: newTitle }));
  }

  changeListValue(newValue) {
    this.setState(() => ({ value: newValue }));
  }

  changeListExecutions(newValue) {
    this.setState(() => ({ executions: newValue }));
  }

  changeQuestionValue(questionId, newQuestionValue) {
    let newQuestionValueNumber = newQuestionValue
      ? Number(newQuestionValue)
      : null;

    // eslint-disable-next-line react/no-access-state-in-setstate
    const newQuestionsArray = this.state.questions;
    const index = this.state.questions.findIndex(
      item => item.id === questionId
    );
    newQuestionsArray[index].value = newQuestionValueNumber;

    const questionValueArray = newQuestionsArray.map(question =>
      Number(question.value)
    );
    let valueSum = questionValueArray.reduce((a, b) => a + b, 0);

    this.setState({
      // currentValueSum: valueSum,
      questions: newQuestionsArray
    });
  }

  setValueShare(valueShareStatus) {
    const questionsArray = this.state.questions.slice();
    const newQuestionsArray = questionsArray.map(question => {
      if (valueShareStatus)
        question.value = this.state.value / this.state.questions.length;

      return question;
    });

    this.setState(() => ({
      shareValue: valueShareStatus,
      questions: newQuestionsArray
    }));
  }

  changeListTime(newTime) {
    this.setState(() => ({ time: newTime }));
  }

  changeListModels(value) {
    this.setState(() => ({ models: value }));
  }

  setNoTime(noTimeStatus) {
    this.setState(() => ({ noTime: noTimeStatus, time: 0 }));
  }

  setFreeExecutions(freeExecutions) {
    this.setState(() => ({ freeExecutions }));
  }

  handleRandom(newRandomValue) {
    this.setState(() => ({ random: newRandomValue }));
  }

  async cancelList() {
    let obj = {
      id: this.state.listId
    };

    this.setState({ loadingSubmit: true });

    await axios
      .post(`${URL.api}evaluation/question/lists/delete`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(Response => {
        this.setState({ loadingSubmit: false });
        this.props.closeModal();
      });
  }

  async finishList() {
    const questionsArray = this.state.questions.slice();

    if (
      questionsArray.find(
        question =>
          question.value === null ||
          question.value === undefined ||
          question.value === ""
      )
    ) {
      toastr.error("Erro", "Há uma questão sem valor definido");
      return;
    }

    const newQuestionsArray = questionsArray.map(question => {
      if (this.state.shareValue) {
        question.value = this.state.value / this.state.questions.length;
      }

      return question;
    });

    this.setState({ questions: newQuestionsArray }, async () => {
      const currentValueSum = this.state.questions.reduce(
        (acc, val) => acc + Number(val.value),
        0
      );

      if (this.state.name === "") {
        toastr.error("Erro", "Favor inserir um nome para sua prova");
        return;
      }
      if (
        !this.state.shareValue &&
        Number(this.state.value) !== currentValueSum
      ) {
        toastr.error(
          "Erro",
          "Valor da prova não corresponde à soma das questões"
        );
        return;
      }

      // A lista só existe no banco depois do createNewList. Ele era disparado
      // sem await ao importar questões, então ao salvar rápido o listId ainda
      // era undefined e o id não chegava a quem consome esta lista.
      let { listId } = this.state;
      if (!listId) {
        listId = await this.createNewList();

        if (!listId) {
          toastr.error("Erro", "Não foi possível criar a lista de exercício.");
          this.setState({ loadingSubmit: false });
          return;
        }
      }

      await this.updateList(listId);

      if (this.props.newList) {
        this.props.newList({ id: listId, name: this.state.name });
      } else {
        this.props.history.push("/evaluation/list");
      }
    });
  }

  async viewList() {
    await this.updateList();
    this.props.history.push(`/question/list/prototype/${this.state.listId}`);
  }

  render() {
    return (
      <div className="question-list-container">
        {this.state.questionsImporter && (
          <QuestionImportModal
            show={this.state.questionsImporter}
            userQuestions={this.state.userQuestions}
            modalCloser={this.closeImporter}
            questionImporter={this.importQuestion}
            questionsImporter={this.importQuestions}
          />
        )}
        <section className="question-list-main-form">
          <input
            type="text"
            value={this.state.name}
            placeholder="Insira um nome para sua prova"
            className="question-list-title"
            onChange={e => this.changeListName(e.target.value)}
            disabled={this.state.used}
          />
          <section className="question-list-value-section">
            <h5>Valor da prova:</h5>
            <input
              type="number"
              value={this.state.value}
              placeholder={this.state.value}
              min="0"
              max="99"
              className="question-list-value-input"
              onChange={e => this.changeListValue(e.target.value)}
              disabled={this.state.used}
            />
            <div className="question-list-section-divisor" />
            <input
              type="checkbox"
              className="question-list-form-checkbox"
              checked={this.state.shareValue}
              onChange={() => this.setValueShare(!this.state.shareValue)}
              disabled={this.state.used}
            />
            <p>Dividir valor igualmente</p>
          </section>
          <section className="question-list-text-input-section">
            <h5>Duração da prova:</h5>
            {!this.state.noTime ? (
              <>
                <input
                  type="number"
                  value={this.state.time}
                  placeholder={this.state.time}
                  min="0"
                  max="999"
                  className="question-list-time-input"
                  onChange={e => this.changeListTime(e.target.value)}
                  disabled={this.state.used}
                />
                <p>minutos</p>
              </>
            ) : (
              <span>Sem limite.</span>
            )}
            <div className="question-list-section-divisor" />
            <input
              type="checkbox"
              className="question-list-form-checkbox"
              checked={this.state.noTime}
              onChange={() => this.setNoTime(!this.state.noTime)}
              disabled={this.state.used}
            />
            <p>Lista sem limite de duração</p>
          </section>
          <section className="question-list-value-section">
            <h5>Execuções:</h5>
            {!this.state.freeExecutions ? (
              <input
                type="number"
                value={this.state.executions}
                placeholder={this.state.executions}
                min="0"
                max="99"
                className="question-list-value-input"
                onChange={e => this.changeListExecutions(e.target.value)}
                disabled={this.state.used}
              />
            ) : (
              <span>Livre.</span>
            )}
            <div className="question-list-section-divisor" />
            <input
              type="checkbox"
              className="question-list-form-checkbox"
              checked={this.state.freeExecutions}
              onChange={() =>
                this.setFreeExecutions(!this.state.freeExecutions)
              }
              disabled={this.state.used}
            />
            <p>Execuções Livres</p>
          </section>
          <section className="question-list-text-input-section">
            <h5>Modelos de prova:</h5>
            <input
              type="number"
              value={this.state.models}
              placeholder={this.state.models}
              min="0"
              max="999"
              className="question-list-time-input"
              onChange={e => this.changeListModels(e.target.value)}
              disabled={this.state.used}
            />
          </section>
          {this.state.used && (
            <Alert color="warning">
              Essa atividade já foi executada, edição indisponível!
            </Alert>
          )}
          <section className="question-list-form-navigation-section">
            {!this.state.used && (
              <section className="question-list-finish-prototype-section">
                {!this.state.loadingSubmit ? (
                  <>
                    <button
                      className="question-list-cancel-button mr-2"
                      type="submit"
                      onClick={() => this.cancelList()}
                    >
                      Apagar
                    </button>
                    <button
                      className="question-list-submit-button mr-2"
                      type="submit"
                      onClick={() => this.finishList()}
                    >
                      Finalizar
                    </button>
                  </>
                ) : (
                  <button className="question-list-submit-button mr-2" disabled>
                    <CSpinner color="secondary" size="sm" />
                  </button>
                )}
              </section>
            )}
          </section>
        </section>
        <section className="question-list-questions">
          {this.state.loadingTypes ? (
            <div className="pt-4 pb-2">
              <Loading />
            </div>
          ) : (
            <>
              <div className="total-questions-title-container">
                {this.state.questions?.length ? (
                  <>
                    <h1 className="display-5 total-questions-title">
                      Total de questões: {this.state.questions?.length}
                    </h1>
                  </>
                ) : (
                  <h1 className="display-5 total-questions-title">
                    Nenhuma questão foi adicionada!
                  </h1>
                )}
              </div>
              <ul className="question-list-question-list">
                {this.state.questions.map((question, index) => (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%"
                      }}
                    >
                      <div className="change-position-arrows-container">
                        <p className="position-question-title display-6 mr-3">
                          {index + 1}° Questão
                        </p>
                        <FaArrowDown
                          size={24}
                          onClick={() => this.pushQuestion(index, -1)}
                          className={`mr-3 ${
                            !this.state.used && "change-position-arrow"
                          }`}
                        />
                        <FaArrowUp
                          size={24}
                          onClick={() => this.pushQuestion(index, 1)}
                          className={`${
                            !this.state.used && "change-position-arrow"
                          }`}
                        />
                      </div>
                    </div>
                    <li
                      className="question-list-question-items"
                      key={question.renderKey || question.id || `new-${index}`}
                    >
                      <QuestionCreate
                        key={
                          question.renderKey || question.id || `new-${index}`
                        }
                        disabled={this.state.used}
                        onActivity
                        questionValue={question.value}
                        valueShare={{
                          totalValue: this.state.value,
                          questionsAmount: this.state.questions.length,
                          shareValue: this.state.shareValue
                        }}
                        questionValueChanger={this.questionValueChanger}
                        questionId={question.id}
                        index={index}
                        listChanger={this.idListChanger}
                        questionDuplicator={this.questionDuplicator}
                        questionDeleter={this.questionDeleter}
                        history={this.props.history}
                        types={this.state.types}
                        abilities={this.state.abilities}
                        modules={this.state.modules}
                        shouldUpdateList={this.shouldUpdateList}
                      />
                    </li>
                  </>
                ))}
              </ul>
              {!this.state.used && (
                <div className="d-flex align-items-center justify-content-center my-2">
                  {/*
                  <button className="question-list-add-question bg-white btn" onClick={() => this.addNewQuestion()}>Criar nova questão</button>
                  <span className="mx-2">ou</span>
                  */}
                  <button
                    className="question-list-add-question bg-white btn d-flex align-items-center justify-content-center mt-2 mb-2"
                    onClick={() => this.openUserQuestionsImporter()}
                  >
                    Adicionar questão <FaPlusCircle className="ml-2" />
                  </button>
                </div>
              )}
            </>
          )}
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionListCreate);
